import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { setGlobalTokenGetter } from "../lib/api/client";

/**
 * Component that sets up global authentication for API calls.
 * Must be rendered inside ClerkProvider and SignedIn.
 */
export function AuthSetup() {
  const { getToken } = useAuth();

  useEffect(() => {
    // Set the global token getter so all API calls include auth
    setGlobalTokenGetter(() => getToken());
  }, [getToken]);

  return null;
}
